import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const FestivalContext = createContext();

const API_KEY = 'AIzaSyBpRk3trsgkXTs4QJCKu-lffOEg9QEtRrg';
const CALENDAR_ID = 'en.indian#holiday@group.v.calendar.google.com';

// Get current year and next 4 years (5 years in total)
const currentYear = new Date().getFullYear();
const nextFiveYears = Array.from({ length: 5 }, (_, i) => currentYear + i);

export const FestivalProvider = ({ children }) => {
  const [festival, setFestival] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHolidays = async () => {
      try {
        let allFestivals = [];
        
        for (const year of nextFiveYears) {
          const timeMin = `${year}-01-01T00:00:00Z`;
          const timeMax = `${year}-12-31T23:59:59Z`;

          const url = `https://www.googleapis.com/calendar/v3/calendars/${encodeURIComponent(
            CALENDAR_ID
          )}/events?key=${API_KEY}&timeMin=${timeMin}&timeMax=${timeMax}&orderBy=startTime&singleEvents=true`;

          const response = await axios.get(url);
          allFestivals = [...allFestivals, ...response.data.items]; // Concatenate all the festivals
        }

        setFestival(allFestivals);
      } catch (err) {
        console.error('Error fetching holidays:', err);
        setError('Error fetching holidays.');
      } finally {
        setLoading(false);
      }
    };

    fetchHolidays();
  }, []);

  return (
    <FestivalContext.Provider value={{ festival, loading, error }}>
      {children}
    </FestivalContext.Provider>
  );
};

export const useFestivalContext = () => useContext(FestivalContext);
